export interface CommunityStat {
  id: string;
  label: string;
  value: number;
  suffix: string;
  icon: string;
  description: string;
}

export const communityStats: CommunityStat[] = [
  {
    id: 'registered-radios',
    label: 'Radios Registradas',
    value: 847,
    suffix: '+',
    icon: 'ri-radio-line',
    description: 'Estaciones activas en la plataforma transmitiendo desde más de 30 países.',
  },
  {
    id: 'hosts',
    label: 'Locutores',
    value: 3200,
    suffix: '+',
    icon: 'ri-mic-line',
    description: 'Voces que dan vida a la radio, conectando con sus comunidades cada día.',
  },
  {
    id: 'programs',
    label: 'Programas',
    value: 12500,
    suffix: '',
    icon: 'ri-calendar-check-line',
    description: 'Contenido original de todos los géneros: música, noticias, deportes y más.',
  },
  {
    id: 'listeners',
    label: 'Oyentes',
    value: 156000,
    suffix: '+',
    icon: 'ri-headphone-line',
    description: 'Personas que descubren, escuchan y comparten radio todos los días.',
  },
  {
    id: 'events',
    label: 'Eventos',
    value: 2340,
    suffix: '',
    icon: 'ri-calendar-event-line',
    description: 'Eventos en vivo, transmisiones especiales y encuentros de la comunidad.',
  },
  {
    id: 'clubs',
    label: 'Clubes',
    value: 523,
    suffix: '',
    icon: 'ri-shield-star-line',
    description: 'Comunidades exclusivas donde los fans más fieles se reúnen.',
  },
  {
    id: 'messages',
    label: 'Mensajes',
    value: 8700000,
    suffix: '',
    icon: 'ri-chat-3-line',
    description: 'Conversaciones en vivo entre oyentes y locutores durante las transmisiones.',
  },
  {
    id: 'reactions',
    label: 'Reacciones',
    value: 4200000,
    suffix: '',
    icon: 'ri-heart-3-line',
    description: 'Emociones compartidas: likes, aplausos, risas y todo tipo de reacciones.',
  },
  {
    id: 'comments',
    label: 'Comentarios',
    value: 1800000,
    suffix: '',
    icon: 'ri-message-3-line',
    description: 'Opiniones, debates y feedback que enriquecen cada programa.',
  },
  {
    id: 'shares',
    label: 'Compartidos',
    value: 920000,
    suffix: '',
    icon: 'ri-share-forward-line',
    description: 'Contenido que la comunidad lleva a sus redes para que más gente descubra RFW.',
  },
];